import React from 'react';
import IconMdi from '@mdi/react';
import { COLORS } from '../color';
var Icon = React.forwardRef(function (props, ref) {
    var _a;
    return (React.createElement(IconMdi, { ref: ref, className: props.className, size: props.size || 1, color: (_a = props.color) !== null && _a !== void 0 ? _a : COLORS.gray600, path: props.path, title: props.title }));
});
export default Icon;
//# sourceMappingURL=Icon.js.map